import { isMobileRes } from "./Utils";


class ParallaxClass{
    constructor(){
        this._items = null;

        this._isMobileRes = false;

        this._initOnDocumentReady = false;

        if(document.readyState === 'loading'){
            document.addEventListener("DOMContentLoaded", this._onDocumentReady.bind(this));
        }else{
            this._onDocumentReady();
        }
    }

    _onDocumentReady(){
        if(this._initOnDocumentReady){
            this._init();
        }
    }
    
    init(){
        if(document.readyState === 'loading'){
            this._initOnDocumentReady = true;
        }else{
            this._init();
        }
    }

    _init(){
        this._isMobileRes = isMobileRes();
        
        this._reset();


        window.addEventListener('scroll', this._onScroll.bind(this));
        window.addEventListener('resize', this._onResize.bind(this));
        
        this._onScroll();
    }

    _reset(){
        this._items = [];
        
        let scrollY = Math.max(document.documentElement.scrollTop, document.body.scrollTop);

        Array.from(document.querySelectorAll('.parallax')).forEach((element)=>{
            element.style.transition = 'none';
            element.style.transform = 'none';
            
            let item = {
                element: element,
                y0: element.getBoundingClientRect().top + scrollY,
                offset: element.hasAttribute('data-parallax-offset') ? element.getAttribute('data-parallax-offset') : 0,
                velocity: element.hasAttribute('data-parallax-velocity') ? element.getAttribute('data-parallax-velocity') : 1,
                axis: element.hasAttribute('data-parallax-axis') ? element.getAttribute('data-parallax-axis') : 'y',
            }

            this._items.push(item);
        })
    }

    _onScroll(){
        if(!this._isMobileRes){
            let scrollY = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
            
            this._items.forEach((item)=>{
                 
                // Opción para no mover todos los elementos de la página
                if(scrollY - window.innerHeight < item.y0 && item.y0 < scrollY + window.innerHeight){
                    
                    let position = Math.round((item.y0 - item.offset - scrollY - window.innerHeight/2) * item.velocity);

                    switch(item.axis){
                        case 'y': 
                            item.element.style.transform = `translateY(${position}px)`;
                        break;
                        case 'x': 
                            item.element.style.transform = `translateX(${position}px)`;
                        break;    
                    }
                }
            })
            
        }
    }

    _onResize(e){
        this._isMobileRes = isMobileRes();
        
        this._reset();
    }
}

const Parallax = new ParallaxClass();
Object.seal(Parallax);

export default Parallax